"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
class Attribution {
    constructor() {
        this.MD_INIT = 1 << 0;
        this.MD_FLAGS = 0;
        this.MD_QUERY_STRING = 1;
        this.MD_LANDING_PAGE = 2;
        this.MD_LAST_PAGE = 3;
        this.DELIM = "&";
    }
    main() {
        const url = document.URL.split("?");
        if (!this.initialized()) {
            console.log("md.save");
            // save arrival time to cookie
            const query = (url[1] || "").split("#")[0];
            this.set_field(this.MD_FLAGS, this.get_field(this.MD_FLAGS) | this.MD_INIT);
            this.set_field(this.MD_QUERY_STRING, encodeURIComponent(query));
            this.set_field(this.MD_LANDING_PAGE, encodeURIComponent(document.URL));
        }
        this.set_field(this.MD_LAST_PAGE, url[0]);
    }
    initialized() {
        return this.get_field(this.MD_FLAGS) & this.MD_INIT;
    }
    get_field(j) {
        return this.get_md().split(this.DELIM)[j];
    }
    set_field(j, x) {
        // determine bucket
        var bucket = this.get_bucket();
        var c = this.get_md().split(this.DELIM);
        c[j] = x;
        this.set_cookie(bucket, c.join(this.DELIM));
    }
    get_cookie(cname) {
        return this.find(cname, document.cookie, "; ", "=");
    }
    get_md() {
        // determine bucket
        var bucket = this.get_bucket();
        var c = this.get_cookie(bucket);
        //workaround and fix for url bug
        try {
            if (c &&
                (typeof c === "string" || c instanceof String) &&
                c.indexOf("%2522%2522") !== -1) {
                c = c.replace("%2522%2522", "");
                this.set_cookie(bucket, c);
            }
        }
        catch (err) { }
        return c || "0";
    }
    set_cookie(cname, val) {
        //workaround and fix for url bug
        try {
            if (val &&
                (typeof val === "string" || val instanceof String) &&
                val.indexOf("%2522%2522") !== -1) {
                val = val.replace("%2522%2522", "");
            }
        }
        catch (err) { }
        var DAY_MS = 24 * 60 * 60 * 1000;
        var days = 180;
        var date = new Date(new Date().getTime() + days * DAY_MS);
        var expires = "expires=" + date;
        var new_cookie = this.cookie_with_domain(cname, val) + expires;
        document.cookie = new_cookie;
    }
    get_bucket() {
        return "mdata";
    }
    find(burnable, tree, horizontally, vertically) {
        let fire = "";
        const logs = tree.split(horizontally);
        for (let i = 0; i < logs.length; ++i) {
            var kindling = logs[i].split(vertically);
            if (kindling[0] == burnable) {
                fire = kindling[1];
            }
        }
        return fire;
    }
    cookie_with_domain(cname, val) {
        var cookie = cname + "=" + val + "; path=/;";
        var domain = this.get_domain();
        return cookie + (domain ? "domain=" + domain + ";" : "");
    }
    get_domain() {
        var maybe = window.location.host.replace(/(.*)(\.openagent.*)/, "$2");
        return (maybe.match(/\./g) || []).length > 2 ? maybe : "";
    }
    landing_page() {
        return decodeURIComponent(this.get_field(this.MD_LANDING_PAGE));
    }
    last_page() {
        return this.get_field(this.MD_LAST_PAGE);
    }
    current_url() {
        return [location.protocol, "//", location.host, location.pathname].join("");
    }
    ref() {
        return this.get_query_val("ref");
    }
    get_query_val(val) {
        return this.find(val, this.get_query(), "&", "=");
    }
    get_query() {
        return decodeURIComponent(this.get_field(this.MD_QUERY_STRING));
    }
}
exports.default = Attribution;
